"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _reduxDynamicModules = require("redux-dynamic-modules");

var _reducers = require("./reducers");

var _myHistory = require("../myHistory");

var _connectedReactRouter = require("connected-react-router");

var history = _myHistory.myHistory;
var enhancer = (0, _redux.applyMiddleware)((0, _connectedReactRouter.routerMiddleware)(history));
var store = (0, _reduxDynamicModules.createStore)({
  initialState: {
    loginReducer: {
      token: localStorage.getItem('TOKEN')
    }
  },
  enhancers: [enhancer]
}, _reducers.LoginModule, _reducers.AppBarModule, (0, _reducers.createRouterModule)(history));
var _default = store;
exports.default = _default;